import {createApp} from 'vue'

import "bootstrap"
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap-icons/font/bootstrap-icons.css"

import '@/styles/css/index.css'
import '@/styles/css/base.css'




import App from './App.vue'
import router from './router'


createApp(App).use(router).mount('#app').data({title: '测试'})
